import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import HeaderWithButton from "../../Utility/HeaderWithButton";
import { PencilSquareIcon, XMarkIcon } from "@heroicons/react/20/solid";
import { Tooltip } from "react-tooltip";
import DeleteConfirmation from "../../Utility/DeleteConfirmation";
import { Dialog } from "@headlessui/react";
import { DataContext } from "../../../helper/HelperOne";
import { Pagination } from "../../../helper/HelperTwo";
import { useToast } from "../../../context/ToastProvider";

const PriorityList = () => {
    const { triggerToast } = useToast();
    const { searchData } = useContext(DataContext);
    const [currentPage, setCurrentPage] = useState(1);

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [priorityListButton, setPriorityListButton] = useState("");
    const [priorityListData, setPriorityListData] = useState([]);
    const [editpriorityList, setEditPriorityList] = useState("");
    const [errors, setErrors] = useState(null);
    const [
        paginationpriorityListData,
        setPaginationPriorityListData,
    ] = useState([]);
    const [editPriorityId, setEditPriorityId] =
        useState("");

    const [priorityListInputs, setPriorityListInputs] = useState({
        priority: "",
    });

    const fetchPriorityList = async (page = 1) => {
        const token = localStorage.getItem("token");
        if (!token) {
            triggerToast("error", "Authorization token is missing", "error");
            // toast.error("Authorization token is missing");
            return;
        }

        try {
            const apiUrl = searchData
                ? `public/api/priorities\?page=${page}&search=${searchData}`
                : `public/api/priorities?page=${page}`;

            const response = await axios.get(apiUrl, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

           

            setPriorityListData(response?.data?.priorities);
            setPaginationPriorityListData(response?.data?.priorities);
        } catch (error) {
            console.error("Error fetching lead sources:", error);
        }
    };
    useEffect(() => {
        fetchPriorityList(currentPage);
    }, [searchData, currentPage]);

    const handleAddPriorityList = () => {
        setPriorityListButton("save");
        setPriorityListInputs({ setPriorityListInputs: "" });
        setIsDialogOpen(true);
    }

    const handleChangeForPriorityList = (e) => {
       
        setPriorityListInputs({
            [e.target.name]: e.target.value,
        });
    };

    const handleSavePriorityList = async (e) => {
        e.preventDefault();
        try {
            
            const token = localStorage.getItem("token");
            const response = await axios.post(
                "public/api/priorities",
                priorityListInputs,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            )
            
            setIsDialogOpen(false);
            triggerToast("success", "Priority added successfully", "success");
            fetchPriorityList();
        } catch (error) {
            triggerToast("error", "Failed to add Priority", "error");
        
            setErrors(error.response.data.errors);
        }
    }

    const handleEditPriorityList = async (id) => {
        setEditPriorityId(id);
        setIsDialogOpen(true);

        try {
            const token = localStorage.getItem("token");
            const response = await axios.get(`public/api/priorities/${id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

           

            const priorityListData = response.data;

            // Correctly setting the state
            setPriorityListInputs({ priority: priorityListData.priority });

            setEditPriorityList(id);
            setPriorityListButton("update");
            setIsDialogOpen(true);

        } catch (error) {
            triggerToast("error", "Failed to fetch Priority for editing", "error");
        }
    }

    const handleUpdatePriorityList = async (e) => {
        e.preventDefault();
        try {
            const token = localStorage.getItem("token");
            setPriorityListButton("update");
            const response = await axios.put(
                `public/api/priorities/${editPriorityId}`,
                priorityListInputs,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            if (response.data) {
                setIsDialogOpen(false);
                triggerToast("success", "Priority updated successfully", "success");
                // toast.success("Priority updated successfully");
                await fetchPriorityList();
            } else {
                triggerToast("error", "Failed to update Priority", "error");
                // toast.error("Failed to update Priority");
            }
        } catch (error) {
            triggerToast("error", "Failed to update Priority", "error");
        }
    }

    return (
        <div>
            <HeaderWithButton
                title="Priority "
                description="Priority"
                buttonText="priority"
                onButtonClick={handleAddPriorityList}
            // showButton={PriorityListPermission}
            />

            <div className="grid grid-cols-1 gap-4 items-start sm:items-center">
                <div className="mt-6 overflow-x-auto rounded-lg shadow">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                                    S No
                                </th>
                                <th className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                                    Priority
                                </th>
                                <th className="py-3 px-5 border-b text-center  text-sm sm:text-base font-normal">
                                    Actions
                                </th>
                            </tr>
                        </thead>

                        <tbody className="bg-white divide-y divide-gray-200 ">
                            {priorityListData?.data?.length > 0 ? (
                                priorityListData?.data.map((item, index) => (
                                    <tr key={index}>
                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
                                            {index + 1}
                                        </td>
                                        <td className="px-6 py-4 whitespace-nowrap text-center text-sm text-gray-500">
                                            {item.priority}
                                        </td>
                                        <td className="my-anchor-edit px-6 py-4 whitespace-nowrap text-right text-sm font-medium flex justify-center">
                                            <>
                                                <button
                                                    className="my-anchor-edit bg-green-400 text-white text-sm py-1 px-2 rounded mr-2 transition duration-200"
                                                    onClick={() =>
                                                        handleEditPriorityList(
                                                            item.id_crypt
                                                        )
                                                    }
                                                >
                                                    <PencilSquareIcon className="h-5 w-5 text-white" />
                                                    <Tooltip
                                                        anchorSelect=".my-anchor-edit"
                                                        place="top"
                                                        className="text-xs p-0"
                                                        style={{ fontSize: "12px", padding: "0.3rem" }}
                                                    >
                                                        Edit
                                                    </Tooltip>
                                                </button>

                                                {/* <DeleteConfirmation
                                                    id_crypt={item.id_crypt}
                                                    apiType="priority"
                                                    fetchClientData={fetchPriorityList}
                                                /> */}
                                            </>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="py-3 px-5 border-b text-center text-sm sm:text-base font-normal">
                                        No Data Found
                                    </td>
                                </tr>

                            )}
                        </tbody>
                    </table>
                </div>
                {isDialogOpen && (
                    <Dialog
                        open={isDialogOpen}
                        onClose={() => setIsDialogOpen(false)}
                        className="relative z-10"
                    >
                        <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-50 backdrop-blur-sm transition-opacity" />
                        <div className="fixed inset-0 z-10 overflow-y-auto">
                            <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                                <Dialog.Panel className="my-auto relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full sm:w-full md:max-w-screen-sm lg:max-w-screen-xl h-full sm:h-auto max-h-[90vh] overflow-y-auto">
                                    <div
                                        className="flex justify-between items-center mb-4 p-4"
                                        style={{ backgroundColor: "#6366f1" }}
                                    >
                                        <h1 className=" text-white mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 uppercase z-100">
                                            Priority
                                        </h1>
                                        <button
                                            type="button"
                                            onClick={() => setIsDialogOpen(false)}
                                        >
                                            <XMarkIcon
                                                className="h-6 w-6 sm:h-8 sm:w-8 text-white cursor-pointer"
                                                aria-hidden="true"
                                            />
                                        </button>
                                    </div>
                                    <div className="w-full max-w-7xl mx-auto p-6 bg-gray-50">
                                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                            <div className="sm:col-span-2">
                                                <form>
                                                    <div className="overflow-hidden sm:rounded-md">
                                                        <div className="space-y-4">
                                                            <div>
                                                                <label
                                                                    htmlFor="priorityList"
                                                                    className="block text-sm font-medium leading-6 text-gray-900"
                                                                >
                                                                    Priority
                                                                </label>
                                                                <div className="mt-2">
                                                                    <input
                                                                        name="priority"
                                                                        type="text"
                                                                        value={priorityListInputs.priority}
                                                                        onChange={handleChangeForPriorityList}
                                                                        autoComplete="mode"
                                                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                                    />
                                                                </div>
                                                                {errors && (
                                                                    <p className="mt-1 text-sm text-red-600">
                                                                        {errors.Priority}
                                                                    </p>
                                                                )}
                                                            </div>

                                                            <div className="flex  space-x-2">
                                                                {priorityListButton === "save" ? (
                                                                    <button
                                                                        onClick={handleSavePriorityList}
                                                                        className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                                    >
                                                                        Add
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        onClick={handleUpdatePriorityList}
                                                                        className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                                                    >
                                                                        Update
                                                                    </button>
                                                                )}
                                                                <button
                                                                    type="button"
                                                                    onClick={() => setIsDialogOpen(false)}
                                                                    className="inline-flex justify-center py-2 px-4 w-auto border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                                                                >
                                                                    Cancel
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </div>
                        </div>
                    </Dialog>
                )}
            </div>
        </div>
    )
}

export default PriorityList